/**
 * SitePick front — カラー切替で選んだ色（商品ごと）。docs/07 §13。
 *
 * 一覧カード → 商品詳細 → 実物確認画面へ、同じタブの間だけ引き継ぐ（sessionStorage `sitepick_colors` = { 投稿 ID: key }）。
 * 使えない環境（プライベートブラウズ等）では何も残さない（その画面の中では切り替えられる）。表示の好みだけで、業務データではない。
 */

const KEY = "sitepick_colors";
const COLOR_RE = /^(?:base|[a-z][a-z0-9-]{0,23})$/;

function readAll() {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    const data = raw ? JSON.parse(raw) : {};
    return data && typeof data === "object" ? data : {};
  } catch {
    return {};
  }
}

/**
 * @param {string} postId
 * @returns {string} 選んだ色の key（無ければ ""）
 */
export function storedColor(postId) {
  const v = readAll()[postId];
  return typeof v === "string" && COLOR_RE.test(v) ? v : "";
}

/**
 * @param {string} postId
 * @param {string} key
 */
export function storeColor(postId, key) {
  if (!/^\d+$/.test(postId) || !COLOR_RE.test(key)) {
    return;
  }
  try {
    const all = readAll();
    if (key === "base") {
      delete all[postId];
    } else {
      all[postId] = key;
    }
    window.sessionStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* 残せなくても切替自体は動く */
  }
}
